import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon/Icon';
import { StatusBadge } from '@dealstack/frontend/shared/components/StatusBadge/StatusBadge';
import { useTranslationInvestor } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { defaultTheme } from '@dealstack/frontend/shared/mechanism/styleguide/defaultTheme';
import { formatStringDateToUI } from '@dealstack/shared/lib/format/dates/date';

interface Props {
	date: string;
}

export const LastVerifiedBadge = ({ date }: Props) => {
	const tInvestor = useTranslationInvestor();

	return (
		<StatusBadge
			color="gray"
			textColor="dark"
			text={`${tInvestor('investment.join.kyc.inherited.last_verified')} ${formatStringDateToUI(date)}`}
			leftSection={
				<Icon
					variant="clock-time-watch"
					size="0.75rem"
					color={defaultTheme.v3.colors.dark[4]}
					fillStroke
				/>
			}
		/>
	);
};
